import {
  VIEW_TYPE_GRID,
  VIEW_TYPE_TABLE,
} from '@/stores/search-creators/searchCreatorsStore';

export const FLOW_NAMES = {
  CAMPAIGN_CREATION: 'campaign_creation',
  AI_STUDIO: 'ai_studio',
  RECRUITMENT_SEARCH: 'recruitment_search',
  BRAND_SAFETY_CREATOR: 'brand_safety_creator',
  MY_CREATORS: {
    INVITE_TO_CAMPAIGN: 'invite_to_campaign',
  },
  CONTENT_STUDIO: {
    TRANSLATE: 'translate',
    REPHRASE: 'rephrase',
    REFORMAT: 'reformat',
    UPSCALE: 'upscale',
    ONBOARDING: 'onboarding',
    ASSETS: 'library',
    PRICING: 'pricing',
  },
  CONTENT_LAB: {
    DUB: 'dub',
    REPHRASE: 'rephrase',
    RESIZE: 'resize',
    CAPTIONS: 'captions',
    AI_AVATAR: 'ai_avatar',
    UPSCALE: 'upscale',
    ONBOARDING: 'onboarding',
    PRICING: 'pricing',
    ASSETS_PREVIEW_MODAL: 'assets_preview_modal',
    PROJECT: 'project',
    PROJECTS: 'projects',
    HOME: 'homepage',
  },
  SUGGESTED_CREATORS_OLD: 'suggested_creators_old',
  SUGGESTED_CREATORS: 'suggested_creators',
};

export const CONTENT_LAB_VIEW_NAMES = {
  HOME: 'homepage',
  DUB: 'dub',
  REPHRASE: 'rephrase',
  RESIZE: 'resize',
  CAPTIONS: 'captions',
  CAPTIONS_TABS: 'captions_tabs',
  CAPTIONS_STYLES: 'captions_styles',
  CAPTIONS_LANGUAGES: 'captions_languages',
  AI_AVATAR: 'ai_avatar',
  UPSCALE: 'upscale',
  ONBOARDING: 'onboarding',
  ONBOARDING_UPLOAD_MODAL: 'onboarding_upload_modal',
  PRICING: 'pricing',
  PROJECTS: 'projects',
  PROJECT: 'project',
  PROJECTS_SHELF: 'projects_shelf',
  HEADER: 'header',
  REPHRASE_VIDEO_DISPLAY: 'rephrase_video_display',
  REPHRASE_ROW_EDITOR: 'rephrase_row_editor',
  CAPTIONS_VIDEO_DISPLAY: 'captions_video_display',
  CAPTIONS_ROW_EDITOR: 'captions_row_editor',
  CREDIT_BOX: 'credit_box',
  REPLACE_VIDEO_MODAL: 'replace_video_modal',
  MENU: 'menu',
  USER_MENU: 'user_menu',
  PREVIEW_ASSET: 'preview_asset',
  DELETE_ASSETS_MODAL: 'delete_assets_modal',
  CREDIT_END_MODAL: 'credit_end_modal',
  ASSET_ERROR: 'asset_error',
  CANCEL_SUBSCRIPTION_MODAL: 'cancel_subscription_modal',
  AI_AVATAR_PRE_GENERATE_SCRIPT: 'ai_avatar_pre_generate_script',
  AI_AVATAR_EDITOR: 'ai_avatar_editor',
  AI_AVATAR_CUSTOMIZE_SCRIPT: 'ai_avatar_customize_script',
  AI_AVATAR_CUSTOMIZE_LAYOUT: 'ai_avatar_customize_layout',
};

export const CONTENT_STUDIO_VIEW_NAMES = {
  HOME: 'homepage',
  ASSETS: 'library',
  REPHRASE_EDITOR: 'rephrase_editor',
  REPHRASE_VIDEO_DISPLAY: 'rephrase_video_display',
  REPHRASE_ROW_EDITOR: 'rephrase_row_editor',
  TRANSLATE_EDITOR: 'translate_editor',
  REFORMAT_EDITOR: 'reformat_editor',
  UPSCALE_EDITOR: 'upscale_editor',
  ONBOARDING: 'onboarding',
  PROJECTS_SHELF: 'projects_shelf',
  HEADER: 'header',
  ASSET_PREVIEW: 'preview',
  PRICING: 'pricing',
  DO_AND_DONT: 'do_and_dont',
};

export const CONTENT_STUDIO_PRICING_VIEW_TYPES = {
  PRICING_PAGE: 'pricing_page',
  PRICING_MODAL: 'pricing_modal',
  CHANGE_CONFIRM_MODAL: 'change_confirm_modal',
};

export const CONTENT_STUDIO_PRICING_SOURCES = {
  TOOL_BAR_UPGRADE_BUTTON: 'tool_bar_upgrade_button',
  EDITOR_GENERATE: 'editor_generate',
  PRICING_MODAL: 'pricing_modal',
  PRICING_PAGE: 'pricing_page',
  SUBSCRIPTION_CHANGE_CONFIRM_MODAL: 'subscription_change_confirm_modal',
  USER_MENU: 'user_menu',
};

export const BRANDS_SAFETY_ACTION_NAMES = {
  VETTING_STATUS_CHANGED: 'Vetting Status Changed',
  VETTING_TRACKING_CHANGED: 'Vetting Tracking Changed',
};

export const EVENT_NAMES = {
  CAMPAIGN_CREATION_INTERACTION: 'campaign_creation_interaction',
  CAMPAIGN_CREATION_PROCESS_STARTED: 'campaign_creation_process_started',
  CAMPAIGN_CREATION_PROCESS_ENDED: 'campaign_creation_process_ended',
  AI_STUDIO_ENTERED: 'ai_studio_entered',
  AI_STUDIO_INTERACTION: 'ai_studio_interaction',
  AI_STUDIO_ASSET_INTERACTION: 'ai_studio_asset_interaction',
  AI_STUDIO_ASSET_IMPORTED: 'ai_studio_asset_imported',
  AI_STUDIO_ASSET_PROCESS_STARTED: 'ai_studio_asset_process_started',
  AI_STUDIO_ASSET_PROCESS_ENDED: 'ai_studio_asset_process_ended',
  RECRUIT_TO_CRM: 'recruit_to_crm',
};

export const SCREEN_NAMES = {
  SEARCH: 'Search',
  SEARCH_CREATORS: {
    [VIEW_TYPE_TABLE]: 'search-list',
    [VIEW_TYPE_GRID]: 'search-cards',
  },
  CREATOR_CRM: 'creator_crm',
  RECRUIT_CRM: 'recruit_crm',
};

export const SOURCE_NAMES = {
  MY_CREATORS: 'my_creators',
};

export const CONTENT_SUBMISSION_ANALYTICS_SCREENS = {
  ASSETS: 'assets',
  ASSETS_GRID: 'assets_grid',
  ASSETS_TABLE: 'assets_table',
  ASSET_DETAIL: 'asset_detail',
  ASSET_MIXED_MEDIA: 'asset_mixed_media',
  ASSET_FILTER_DRAWER: 'asset_filter_drawer',
  ASSET_ACTION_MODAL: 'asset_action_modal',
} as const;

export const CONTENT_SUBMISSION_ANALYTICS_BUTTONS = {
  PHASE_TAB: 'phase_tab',
  FILTER_TOGGLE: 'filter_toggle',
  CREATOR_FILTER: 'creator_filter',
  ASSET_CARD: 'asset_card',
  ASSET_CARD_MENU_OPEN: 'asset_card_menu_open',
  FILTER_APPLY: 'filter_apply',
  FILTER_CLEAR_ALL: 'filter_clear_all',
  FILTER_CONTENT_TYPE: 'filter_content_type',
  FILTER_STATUS: 'filter_status',
  VERSION_SELECTOR: 'version_selector',
  SWITCH_TO_LATEST_VERSION: 'switch_to_latest_version',
  ACTIVITY_TAB: 'activity_tab',
  COMMENT_SUBMIT: 'comment_submit',
  NAV_PREVIOUS: 'nav_previous',
  NAV_NEXT: 'nav_next',
  ACTION_APPROVE: 'action_approve',
  ACTION_REQUEST_EDITS: 'action_request_edits',
  ACTION_ARCHIVE: 'action_archive',
  ACTION_UNARCHIVE: 'action_unarchive',
  ACTION_SHARE: 'action_share',
  ACTION_DOWNLOAD: 'action_download',
  ACTION_RUN_AI_ANALYSIS: 'action_run_ai_analysis',
  ACTION_VIEW_AI_ANALYSIS: 'action_view_ai_analysis',
  ACTION_RESIZE: 'action_resize',
  RESIZE_STARTED: 'resize_started',
  RESIZE_LIMIT_REACHED: 'resize_limit_reached',
  RESIZE_INELIGIBLE: 'resize_ineligible',
  RESIZE_PLAYGROUND_CTA: 'resize_playground_cta',
  RESIZE_CONTACT_SALES: 'resize_contact_sales',
  RESIZE_GENERATION_PLAY: 'resize_generation_play',
  RESIZE_GENERATION_DOWNLOAD: 'resize_generation_download',
  ACTION_COMMENT: 'action_comment',
  APPROVAL_MODAL_DEPARTMENT_SELECT: 'approval_modal_department_select',
  APPROVAL_MODAL_DEPARTMENT_DESELECT: 'approval_modal_department_deselect',
  APPROVAL_MODAL_CONFIRM: 'approval_modal_confirm',
  SORT_CHANGE: 'sort_change',
  SHARE_ALL: 'share_all',
  DOWNLOAD_ALL: 'download_all',
  VIEW_TYPE_CHANGE: 'view_type_change',
} as const;
